export enum ApplicationModeType {
  Entry = 'ENTRY',
  Quality = 'QUALITY',
  Undefined = 'UNDEFINED',
}
